import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { PanelMenuModule } from 'primeng/panelmenu';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { PasswordModule } from 'primeng/password';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ProgressBarModule } from 'primeng/progressbar';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { SkeletonModule } from 'primeng/skeleton';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
    declarations: [],
    providers: [MessageService],
    imports: [
        CommonModule,
        SidebarModule,
        ButtonModule,
        PanelMenuModule,
        CardModule,
        InputTextModule,
        RippleModule,
        PasswordModule,
        ToastModule,
        ProgressBarModule,
        TooltipModule,
        DividerModule,
        SkeletonModule,
        InputNumberModule,
        DropdownModule,
    ],
    exports: [
        SidebarModule,
        ButtonModule,
        PanelMenuModule,
        CardModule,
        InputTextModule,
        RippleModule,
        PasswordModule,
        ToastModule,
        ProgressBarModule,
        TooltipModule,
        DividerModule,
        SkeletonModule,
        InputNumberModule,
        DropdownModule,
    ],
})
export class PrimengModule {}
